/**
 * Switches the visible collection inside a product carousel.
 *
 * Every collection is rendered as its own track; the chips toggle which track is shown.
 * Rendering all tracks up front keeps switching instant and avoids a network round trip,
 * at the cost of a larger first response, which is why the section caps the product count.
 */
class ProductCarousel extends HTMLElement {
  connectedCallback() {
    this.chips = this.closest('.product-carousel')?.querySelectorAll('[data-collection]') ?? [];
    this.panels = this.querySelectorAll('[data-panel]');

    for (const chip of this.chips) {
      chip.addEventListener('click', this.onChipClick);
    }
  }

  disconnectedCallback() {
    for (const chip of this.chips) {
      chip.removeEventListener('click', this.onChipClick);
    }
  }

  /** @param {MouseEvent} event */
  onChipClick = (event) => {
    const chip = event.currentTarget;
    if (!(chip instanceof HTMLElement)) return;

    const id = chip.dataset.collection;

    for (const other of this.chips) {
      other.setAttribute('aria-pressed', String(other === chip));
    }

    for (const panel of this.panels) {
      const matches = panel.dataset.panel === id;
      panel.hidden = !matches;
      if (matches) panel.scrollTo({ left: 0 });
    }
  };
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel);
}
